import React, { useState, useEffect } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

import Menu from "../../components/menu/Menu";
import MenuGeral from "../../components/menu/MenuGeral";

import Grafico from "../../components/graficos/Grafico";
import Loader from "../../utils/Loader"; //2025-08-20
import { calcPresencas } from "../../services/presencasService";
import { getModalidadesPagamento } from "../../services/caixaService";
import { getEvolucaoAtivos } from "../../services/ativosService"; //2025-09-05
import { getAbreviatura } from "../../services/userService"; //2025-09-28

function Dashboard() {
  const navigate = useNavigate();

  let decoded = null;
  const isAuth = localStorage.getItem("token") !== null;
  if (isAuth) decoded = jwtDecode(localStorage.getItem("token"));

  const [refresh, setRefresh] = useState(true);

  const [customerAbreviatura, setCustomerAbreviatura] = useState("");

  //
  //let _cancelamentos = []
  const [cancelamentosHomologo, setCancelamentosHomologo] = useState([]);

  const [pendentesMesAtual, setPendentesMesAtual] = useState(0); //2025-09-22

  const [infoGraficoAtivos, setinfoGraficoAtivos] = useState({
    options: {
      chart: {
        id: "apexchart-ativos",
        height: 350,
      },
      xaxis: {
        categories: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
      },
      colors: ["#B8B69E", "#D4CF70", "#FEB019", "#008FFB"],
      dataLabels: {
        enabled: false,
        enabledOnSeries: [3]
      },
      yaxis : {
        min : 0
      },
      tooltip: {
        fixed: {
          enabled: false,
          position: "topLeft", // topRight, topLeft, bottomRight, bottomLeft
          offsetY: 30,
          offsetX: 60,
        },
      },
    },
    series: [
      {
        name: (new Date().getFullYear() - 3).toString(),
        type: "line",
        hidden : true,
        data: [],
      },
      {
        name: (new Date().getFullYear() - 2).toString(),
        type: "line",
        hidden : true,
        data: [],
      },
      {
        name: (new Date().getFullYear() - 1).toString(),
        type: "line",
        hidden : true,
        data: [],
      },
      {
        name: new Date().getFullYear().toString(),
        type: "line",
        data: [],
      },
    ],
  });

  const [infoGraficoInscricoes, setinfoGraficoInscricoes] = useState({
    options: {
      chart: {
        id: "apexchart-incricoes",
        height: 350,
      },
      xaxis: {
        categories: [],
      },
      colors: ["#008FFB", "#00FBF3", "#B8B69E", "#FEB019"],
      dataLabels: {
        enabled: false
      },
      yaxis : {
        min : 0
      },
      tooltip: {
        fixed: {
          enabled: false,
          position: "topLeft", // topRight, topLeft, bottomRight, bottomLeft
          offsetY: 30,
          offsetX: 60,
        },
      },
    },
    series: [
      {
        name: "Inscrições",
        type: "line",
        data: [],
      },
      {
        name: "Reinscrições",
        type: "line",
        hidden : true,
        data: [],
      },
      {
        name: "Devedores",
        type: "line",
        hidden : true,
        data: [],
      },
      {
        name: "Cancelamentos",
        type: "line",
        hidden : true,
        data: [],
      },
    ],
  });


{/*  const [infoGraficoAtivos, setinfoGraficoAtivos] = useState({
    options: {
      chart: {
        id: "apexchart-ativos",
        height: 350,
      },
      stroke: {
        curve: ["smooth", "straight", "smooth"],
        width: [4, 1, 1],
      },
      xaxis: {
        categories: [],
      },
      colors: ["#008FFB", "#FEB019", "#CC3300"],
      dataLabels: {
        enabled: true,
        enabledOnSeries: [1],
      },
      yaxis: [
        {
          title: {
            text: "Ativos",
          },
        },
        {
          opposite: true,
          title: {
            text: "Inscrições",
          },
        },
        {
          opposite: true,
          title: {
            text: "Cancelamentos",
          },
        },
      ],
      tooltip: {
        fixed: {
          enabled: false,
          position: "topLeft", // topRight, topLeft, bottomRight, bottomLeft
          offsetY: 30,
          offsetX: 60,
        },
      },
    },
    series: [
      {
        name: "Ativos",
        type: "line",
        data: [],
      },
      {
        name: "Inscrições",
        type: "column",
        data: [],
      },
      {
        name: "Cancelamentos",
        type: "line",
        data: [],
      },
    ],
  });
*/}

  //

  const [infoGraficoEntradas, setinfoGraficoEntradas] = useState({
    options: {
      chart: {
        id: "apexchart-acessos",
        height: 350,
      },
      xaxis: {
        categories: [],
      },
      dataLabels: {
        enabled: false,
        enabledOnSeries: [2]
      },
      plotOptions : {
        bar: {
          borderRadius : 10
        }
      },
      colors: ["#1E90FF","#FFC0CB","#E0BB72"],
    },
    series: [],
  });

  const [infoGraficoModalidadesReceitas, setinfoGraficoModalidadesReceitas] = useState({
    options: {
      chart: {
        id: "apexchart-receitas-modalidades",
        height: 250,
      },
      labels: [],
   },
    series: [],
  });


  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true); //2025-08-20

  const [estab, setEstab ] = useState(''); //2025-09-28

  useEffect(() => {
    const token = localStorage.getItem("token");

    setIsLoading(true);

    getAbreviatura(token)
      .then(response => {
        setCustomerAbreviatura(response.customerAbreviatura);
      })
      .catch((err) => {
        if (err.response && err.response.status === 401)
          //return history.push("/");
          return navigate("/");

        setError(err.response ? err.response.data : err.message);
      });

    getEvolucaoAtivos(token, estab)
      .then((response) => {
        // console.log("RESPONSE:  ", response);

        const responseR = response.reverse();
        // console.log("REVERSE: ", responseR);

        const meses = responseR.map((o) => o.coluna1);
        //console.log("meses", meses);

        const emDia = responseR.map((o) =>
          o.coluna4 === "" ? 0 : parseInt(o.coluna4)
        );
        //console.log("ativos: ", emDia);

        const inscricoes = responseR.map((o) =>
          o.coluna9 === "" ? 0 : parseInt(o.coluna9)
        );
        //console.log("inscricoes", inscricoes);

        const reinscricoes = responseR.map((o) =>
          o.coluna10 === "" ? 0 : parseInt(o.coluna10)
        );
        //console.log("reinscricoes: ", reinscricoes);

        const cancelamentos = responseR.map((o) =>
          o.coluna7 === "" ? 0 : parseInt(o.coluna7)
        );
        //console.log("cancelamentos", cancelamentos);

	// devedores
        const devedores = responseR.map((o) =>
          o.coluna14 === "" ? 0 : parseInt(o.coluna14)
        );

	// 2025-11-25 desistências
        const desistencias = responseR.map((o) =>
          o.coluna6 === "" ? 0 : parseInt(o.coluna6)
        );
        // console.log("desistencias", desistencias)

        //2025-09-22
        const pendentes = responseR.map((o) =>
          o.coluna8 === "" ? 0 : parseInt(o.coluna8)
        );
        //console.log("pendentes: ", pendentes);

        setPendentesMesAtual(pendentes[pendentes.length - 2]);
        
        setCancelamentosHomologo(cancelamentos.slice(cancelamentos.length-12-3, cancelamentos.length-1));
        //console.log("CANCELAMENTOS_HOMOLOGOS: ", cancelamentosHomologo);

        setinfoGraficoAtivos({
          options: {
            ...infoGraficoAtivos.options,
            xaxis: {
              ...infoGraficoAtivos.options.xaxis,
              //2025-09-10 categories: meses,
            },
          },

          /* 2025-11-03
          series: infoGraficoAtivos.series.map((serie) => {
            if (serie.name === new Date().getFullYear() -3) {
              return { ...serie, data: emDia.slice(0, 12) };
            } else {
              if (serie.name === new Date().getFullYear() -2) {
                return { ...serie, data: emDia.slice(12, 24) };
              } else {
                if (serie.name === new Date().getFullYear() -  1) {
                  return { ...serie, data: emDia.slice(24, 36) };
                } else {
                  if (serie.name === new Date().getFullYear()) {
                    let ano_atual = [];

		    //2025-09-10
                    //ano_atual = emDia.slice(36);
                      ano_atual = emDia.slice(36, emDia.length-1);
                  
                 
                    //2025-09-19 ano_atual.splice(ano_atual.length, 0, "0", "0");
                    //console.log("ano_atual: ", ano_atual)
                    return { ...serie, data: ano_atual };
                  }
                }
              }
            }
          }),
          */


          series: infoGraficoAtivos.series.map((serie) => {
            if (serie.name === (new Date().getFullYear() - 3).toString()) {
              let ativos = [];

              try {
                ativos = response
                  .filter((r) =>
                    r.coluna1.includes(
                      (new Date().getFullYear() - 3).toString()
                    )
                  )
                  .map((f) => parseInt(f.coluna4));
              } catch (error) {
                console.error(error);
              }

              //for (let i = ativos.length - 1; i < 12; i++) ativos.push(0);

              if (ativos.length < 12)
                for (let i = ativos.length; i < 12; i++) ativos.unshift(0); // adds the specified elements to the beginning of an array

              return { ...serie, data: ativos };
            } else {
              if (serie.name === (new Date().getFullYear() - 2).toString()) {
                let ativos = [];

                try {
                  ativos = response
                    .filter((r) =>
                      r.coluna1.includes(
                        (new Date().getFullYear() - 2).toString()
                      )
                    )
                    .map((f) => parseInt(f.coluna4));
                } catch (error) {
                  console.error(error);
                }

                //for (let i = 0; i < 12; i++) if (!ativos[i]) ativos.push(0);
                if (ativos.length < 12)
                  for (let i = ativos.length; i < 12; i++) ativos.unshift(0); // adds the specified elements to the beginning of an array

                return { ...serie, data: ativos };
              } else {
                if (serie.name === (new Date().getFullYear() - 1).toString()) {
                  let ativos = [];

                  try {
                    ativos = response
                      .filter((r) =>
                        r.coluna1.includes(
                          (new Date().getFullYear() - 1).toString()
                        )
                      )
                      .map((f) => parseInt(f.coluna4));
                  } catch (error) {
                    console.error(error);
                  }

                  //for (let i = 0; i < 12; i++) if (!ativos[i]) ativos.push(0);
                  if (ativos.length < 12)
                    for (let i = ativos.length; i < 12; i++) ativos.unshift(0); // adds the specified elements to the beginning of an array

                  return { ...serie, data: ativos };
                } else {
                  if (serie.name === new Date().getFullYear().toString()) {
                    let ativos = [];

                    try {
                      ativos = response
                        .filter((r) =>
                          r.coluna1.includes(
                            new Date().getFullYear().toString()
                          )
                        )
                        .map((f) => parseInt(f.coluna4));
                    } catch (error) {
                      console.error(error);
                    }

                    if (ativos.length > new Date().getMonth() + 1) ativos.pop();
                    return { ...serie, data: ativos };
                  }
                }
              }
            }
          }),
          tooltip: { ...infoGraficoAtivos.tooltip },
        });

        setinfoGraficoInscricoes({
          options: {
            ...infoGraficoInscricoes.options,
            xaxis: {
              ...infoGraficoInscricoes.options.xaxis,
              categories: meses.slice(meses.length-12-2, meses.length-1),
            },
          },

          series: infoGraficoInscricoes.series.map((serie) => {
              if (serie.name === "Inscrições") {
                return { ...serie, data: inscricoes.slice(inscricoes.length-12-2, inscricoes.length-1) };
              } else if (serie.name === "Reinscrições") {
                return { ...serie, data: reinscricoes.slice(reinscricoes.length-12-2, reinscricoes.length-1)};
              } else if (serie.name === "Cancelamentos") {
                
                // 2025-11-25
                //return { ...serie, data: cancelamentos.slice(cancelamentos.length-12-2, cancelamentos.length-2)};
                // return { ...serie, data: [...cancelamentos.slice(cancelamentos.length-12-2 + 1, cancelamentos.length-2), "88"]};
                //return { ...serie, data: [...cancelamentos.slice(cancelamentos.length-12-2 + 1, cancelamentos.length-2), desistencias[desistencias.length-1]]};
                
                // 2025-12-26
                return { ...serie, data: [...cancelamentos.slice(cancelamentos.length-12-2, cancelamentos.length-2), desistencias[desistencias.length-2] ]};

              } else if (serie.name === "Devedores") {
                  return { ...serie, data: devedores.slice(devedores.length-12-2, devedores.length-2)};
              }
          }),
          tooltip: { ...infoGraficoInscricoes.tooltip },
        });

      })
      .catch((err) => {
        if (err.response && err.response.status === 401)
          //return history.push("/");
          return navigate("/");

        setError(err.response ? err.response.data : err.message);
      });

   //





    const periodo = moment.duration(7, "days");
    const data1 = moment().subtract(periodo);

    calcPresencas(
      token,
      data1.format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD")
    )
      .then((response) => {
        
        let datas = [];

        //2025-08-20
        //response.count.forEach((i, index) => datas.push(i.data));
        for (let i = 0; i < 7; i++) {
          let d = new Date();
          d.setDate(d.getDate() - 6 + i);
          datas.push(d.toISOString().split("T")[0]);
        }

        //console.log("Presencas - datas: ", datas);

        let entradas = [];
        let entradas_masculino = [];
        let entradas_feminino = [];

        //2025-08-20
        //response.count.forEach((i) => entradas.push(i.count));

        /*
        for (let i = 0; i < 7; i++) {
          const e = response.count.find((e) => e.data === datas[i]);
          if (e) 
            entradas.push(e.count);
          else 
            entradas.push(0);
        }
        */

        for (let i = 0; i < 7; i++) {
          const e = response.find((e) => e.data === datas[i] && e.sexo === 1);
          if (e) 
            entradas_masculino.push(e.count);
          else 
            entradas_masculino.push(0);
        }

        //console.log("Presencas - M: ", entradas_masculino);

        for (let i = 0; i < 7; i++) {
          const e = response.find((e) => e.data === datas[i] && e.sexo === 0);
          if (e) 
            entradas_feminino.push(e.count);
          else 
            entradas_feminino.push(0);          
        }

        //console.log("Presencas - F: ", entradas_feminino);

        for (let i = 0; i < 7; i++) {
          entradas.push(entradas_masculino[i] + entradas_feminino[i])
        }


        setinfoGraficoEntradas({
          ...infoGraficoEntradas,
          options: {
            ...infoGraficoEntradas.options,
            xaxis: {
              ...infoGraficoEntradas.options.xaxis,
              categories: datas,
            },
          },
          series: [
            {
              name: "Masculino",
              type: "column",
              data: entradas_masculino,
            },
            {
              name: "Feminino",
              type: "column",
              data: entradas_feminino,
            },
            {
              name: "Total",
              type: "line",
              data: entradas,
            },
          ]
        });

        //2025-08-20
        getModalidadesPagamento(token)
          .then(response => {
            

	    let labels = [];
            response.forEach((i, index) => labels.push(i.modalidade));

	    let valores = [];
            response.forEach((i, index) => valores.push(i.valor));


            setinfoGraficoModalidadesReceitas({
              ...infoGraficoModalidadesReceitas,
              options: {
                ...infoGraficoModalidadesReceitas.options,
                labels: labels,
              },
              series: valores,
            });
 


            setIsLoading(false); //2025-08-20
          })
          .catch((err) => {
            if (err.response && err.response.status === 401) return navigate("/");

            setError(err.response ? err.response.data : err.message);
            setIsLoading(false); //2025-08-20
          });
          

        // setIsLoading(false); //2025-08-20

      })
      .catch((err) => {
        if (err.response && err.response.status === 401) return navigate("/");

        setError(err.response ? err.response.data : err.message);
        setIsLoading(false); //2025-08-20
      });
  }, [estab, refresh]);

  const positivo = (
    <svg
      className="icon icon-xs text-success"
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
        clipRule="evenodd"
      ></path>
    </svg>
  );

  const negativo = (
    <svg
      className="icon icon-xs text-danger"
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
  
  return (
    <>
      { decoded && decoded.isAdmin ? <Menu /> : <MenuGeral />}
      <main className="content">

        {/*<div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
          <div className="d-block mb-2 mb-md-0">
            <h1 className="h4">Dashboard</h1>
          </div>
        </div>*/}
        {isLoading ? (
          <Loader />
        ) : (
          <>

          {customerAbreviatura === "KO" && 
            (
            <div className="d-flex align-items-center justify-content-between">
              <label style={{marginTop: "16px"}}>
                Centro:{" "}
                <select style={{padding: "16px 12px"}} onChange={(e) => {setEstab(e.target.value === "todos" ? '' : e.target.value )}}>
                  <option value="todos">TODOS</option>
                  <option value="ko">KO</option>
                  <option value="avenida">Avenida</option>
                </select>
              </label>
              <button
                onClick={() => {
                  setRefresh(r => !r);
                }}
              >
                Atualizar
              </button>
            </div>
            )
          }

          {customerAbreviatura !== "KO" && 
            (
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-3">
              {/*<div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-3">*/}
                <div className="d-block mb-md-0">
                  <h1 className="h4">Dashboard</h1>
                </div>
                <div>
                  <button
                    onClick={() => {
                      setRefresh((r) => !r);
                    }}
                  >
                    Atualizar
                  </button>
                </div>
              {/*</div>*/}
            </div>
            )
          }

          <div className="row">
            <div className="col-12 col-sm-6 col-xl-3 mt-2">
              <div className="card border-0 shadow">
                <div className="card-body">
                  <div className="row d-block d-xl-flex align-items-center">
                    <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                      <div className="icon-shape icon-shape-secondary rounded me-2 me-sm-0">

                        <svg className="icon" width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path opacity="0.5" d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z" fill="currentColor"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M13.25 6.25C12.8358 6.25 12.5 6.58579 12.5 7C12.5 7.41421 12.8358 7.75 13.25 7.75H15.1893L11.4697 11.4697L7.75 15.1893V13.25C7.75 12.8358 7.41421 12.5 7 12.5C6.58579 12.5 6.25 12.8358 6.25 13.25V17C6.25 17.4142 6.58579 17.75 7 17.75H10.75C11.1642 17.75 11.5 17.4142 11.5 17C11.5 16.5858 11.1642 16.25 10.75 16.25H8.81066L12.5303 12.5303L16.25 8.81066V10.75C16.25 11.1642 16.5858 11.5 17 11.5C17.4142 11.5 17.75 11.1642 17.75 10.75V7C17.75 6.58579 17.4142 6.25 17 6.25H13.25Z" fill="#1C274C"/>
                        </svg>
                        
                      </div>
                      <div className="d-sm-none">
                        {/*<h4 className="fw-extrabold h5">Sócios ativos <span className="text-gray-500">(mês atual)</span></h4>*/}
                        <h4 className="fw-extrabold h5">Sócios ativos do mês</h4>
                        <h3 className="mb-1">
                          {infoGraficoAtivos.series[3].data[new Date().getMonth()]}
                        </h3>
                      </div>
                    </div>
                    <div className="col-12 col-xl-7 px-xl-0">
                      <div className="d-none d-sm-block">
                        {/*<h2 className="h6 text-gray-400 mb-0">Sócios ativos <span className="text-gray-500">(mês atual)</span></h2>*/}
                        <h2 className="h6 text-gray-400 mb-0">Sócios ativos do mês</h2>
                        <h3 className="fw-extrabold mb-2">
                          {infoGraficoAtivos.series[3].data[new Date().getMonth()]}
                        </h3>
                      </div>
                      {/*
                      <small className="d-flex align-items-center text-gray-500">
                        {"01"} -{" "}
                        {"10"},
                      </small>
                      */}
                      <div className="d-flex justify-content-between">
                      <div className="small d-flex mt-1 me-1">
                        <div>
                          Mês anterior{" "}
                          <small
                            className={
                              new Date().getMonth() === 0
                                ? infoGraficoAtivos.series[3].data[new Date().getMonth()] > infoGraficoAtivos.series[2].data[infoGraficoAtivos.series[2].data.length - 1] ? "text-success fw-bolder" : infoGraficoAtivos.series[3].data[new Date().getMonth()] < infoGraficoAtivos.series[2].data[infoGraficoAtivos.series[2].data.length - 1] ? "text-danger fw-bolder" : "text-info fw-bolder"
                                : infoGraficoAtivos.series[3].data[new Date().getMonth()] > infoGraficoAtivos.series[3].data[new Date().getMonth() - 1] ? "text-success fw-bolder" : infoGraficoAtivos.series[3].data[new Date().getMonth()] < infoGraficoAtivos.series[3].data[new Date().getMonth() - 1] ? "text-danger fw-bolder" : "text-info fw-bolder"
                            }
                          >
                            {new Date().getMonth() === 0
                                ? infoGraficoAtivos.series[3].data[new Date().getMonth()] > infoGraficoAtivos.series[2].data[infoGraficoAtivos.series[2].data.length - 1] ? positivo 
                                  : infoGraficoAtivos.series[3].data[new Date().getMonth()] < infoGraficoAtivos.series[2].data[infoGraficoAtivos.series[2].data.length - 1] ? negativo : ''
                                : infoGraficoAtivos.series[3].data[new Date().getMonth()] > infoGraficoAtivos.series[3].data[new Date().getMonth() - 1] ? positivo : negativo
                            }
                            {new Date().getMonth() === 0 ? Math.abs((((infoGraficoAtivos.series[3].data[new Date().getMonth()] / infoGraficoAtivos.series[2].data[infoGraficoAtivos.series[2].data.length - 1]) - 1) * 100).toFixed(2)) : Math.abs((((infoGraficoAtivos.series[3].data[new Date().getMonth()] / infoGraficoAtivos.series[3].data[new Date().getMonth() - 1]) - 1) * 100).toFixed(2))}%
                          </small>
                        </div>
                      </div>
                      <div className="small d-flex mt-1">
                        <div>
                          Mês homólogo{" "}
                          <small
                            className={
                              infoGraficoAtivos.series[3].data[new Date().getMonth()] > infoGraficoAtivos.series[2].data[new Date().getMonth()]
                                ? "text-success fw-bolder"
                                : infoGraficoAtivos.series[3].data[new Date().getMonth()] < infoGraficoAtivos.series[2].data[new Date().getMonth()] ? "text-danger fw-bolder" : "text-info fw-bolder"
                            }
                          >
                            {infoGraficoAtivos.series[3].data[new Date().getMonth()] > infoGraficoAtivos.series[2].data[new Date().getMonth()]
                              ? positivo
                              : infoGraficoAtivos.series[3].data[new Date().getMonth()] < infoGraficoAtivos.series[2].data[new Date().getMonth()] ? negativo : ''}
                            {Math.abs((((infoGraficoAtivos.series[3].data[new Date().getMonth()] / infoGraficoAtivos.series[2].data[new Date().getMonth()]) - 1) * 100).toFixed(2))}%
                          </small>
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div className="col-12 col-sm-6 col-xl-3 mt-2">
              <div className="card border-0 shadow">
                <div className="card-body">
                  <div className="row d-block d-xl-flex align-items-center">
                    <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                      <div className="icon-shape icon-shape-secondary rounded me-4 me-sm-0">

                        <svg className="icon "width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path opacity="0.5" d="M12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22Z" fill="currentColor"/>
                          <path d="M15 12.75C15.4142 12.75 15.75 12.4142 15.75 12C15.75 11.5858 15.4142 11.25 15 11.25H9C8.58579 11.25 8.25 11.5858 8.25 12C8.25 12.4142 8.58579 12.75 9 12.75H15Z" fill="#1C274C"/>
                        </svg>

                      </div>
                      <div className="d-sm-none">
                        <h4 className="fw-extrabold h5">Pendentes do mês</h4>
                        <h3 className="mb-1">
                          {pendentesMesAtual}
                        </h3>
                      </div>
                    </div>
                    <div className="col-12 col-xl-7 px-xl-0">
                      <div className="d-none d-sm-block">
                        <h2 className="h6 text-gray-400 mb-0">Pendentes do mês</h2>
                        <h3 className="fw-extrabold mb-2">
                          {/*infoGraficoInscricoes.series[2].data[infoGraficoInscricoes.series[2].data.length - 2]*/}
                          {pendentesMesAtual}
                        </h3>
                      </div>                      
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div className="col-12 col-sm-6 col-xl-3 mt-2">
              <div className="card border-0 shadow">
                <div className="card-body">
                  <div className="row d-block d-xl-flex align-items-center">
                    <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                      <div className="icon-shape icon-shape-secondary rounded me-4 me-sm-0">

                        <svg className="icon" width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path opacity="0.5" d="M12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22Z" fill="currentColor"/>
                          <path d="M12 8.25C12.4142 8.25 12.75 8.58579 12.75 9V11.25H15C15.4142 11.25 15.75 11.5858 15.75 12C15.75 12.4142 15.4142 12.75 15 12.75H12.75L12.75 15C12.75 15.4142 12.4142 15.75 12 15.75C11.5858 15.75 11.25 15.4142 11.25 15V12.75H9C8.58579 12.75 8.25 12.4142 8.25 12C8.25 11.5858 8.58579 11.25 9 11.25H11.25L11.25 9C11.25 8.58579 11.5858 8.25 12 8.25Z" fill="#1C274C"/>
                        </svg>

                      </div>
                      <div className="d-sm-none">
                        <h4 className="fw-extrabold h5">Inscrições do mês</h4>
                        <h3 className="mb-1">
                          {infoGraficoInscricoes.series[0].data[infoGraficoInscricoes.series[0].data.length - 1]}
                        </h3>
                      </div>
                    </div>
                    <div className="col-12 col-xl-7 px-xl-0">
                      <div className="d-none d-sm-block">
                        <h2 className="h6 text-gray-400 mb-0">Inscrições do mês</h2>
                        <h3 className="fw-extrabold mb-2">
                          {infoGraficoInscricoes.series[0].data[infoGraficoInscricoes.series[0].data.length - 1]}
                        </h3>
                      </div>
                      {/*
                      <small className="d-flex align-items-center text-gray-500">
                        {"01"} -{" "}
                        {"10"},
                      </small>
                      */}
                      <div className="d-flex justify-content-between">
                      <div className="small d-flex mt-1 me-2">
                        <div>
                          M. anterior{" "}
                          <small
                            className={
                              infoGraficoInscricoes.series[0].data[infoGraficoInscricoes.series[0].data.length - 1] > infoGraficoInscricoes.series[0].data[infoGraficoInscricoes.series[0].data.length - 2]
                                ? "text-success fw-bolder"
                                : infoGraficoInscricoes.series[0].data[infoGraficoInscricoes.series[0].data.length - 1] < infoGraficoInscricoes.series[0].data[infoGraficoInscricoes.series[0].data.length - 2] ? "text-danger fw-bolder" : "text-info fw-bolder"
                            }
                          >
                            {infoGraficoInscricoes.series[0].data[infoGraficoInscricoes.series[0].data.length - 1] > infoGraficoInscricoes.series[0].data[infoGraficoInscricoes.series[0].data.length - 2]
                              ? positivo
                              : infoGraficoInscricoes.series[0].data[infoGraficoInscricoes.series[0].data.length - 1] < infoGraficoInscricoes.series[0].data[infoGraficoInscricoes.series[0].data.length - 2] ? negativo : ''}
                            {Math.abs((((infoGraficoInscricoes.series[0].data[infoGraficoInscricoes.series[0].data.length - 1] / infoGraficoInscricoes.series[0].data[infoGraficoInscricoes.series[0].data.length - 2]) - 1) * 100).toFixed(2))}%
                          </small>
                        </div>
                      </div>
                      <div className="small d-flex mt-1">
                        <div>
                          M. homólogo{" "}
                          <small
                            className={
                              infoGraficoInscricoes.series[0].data[infoGraficoInscricoes.series[0].data.length - 1] > infoGraficoInscricoes.series[0].data[infoGraficoInscricoes.series[0].data.length - 1 -12]
                                ? "text-success fw-bolder"
                                : infoGraficoInscricoes.series[0].data[infoGraficoInscricoes.series[0].data.length - 1] < infoGraficoInscricoes.series[0].data[infoGraficoInscricoes.series[0].data.length - 1 -12] ? "text-danger fw-bolder" : "text-info fw-bolder"
                            }
                          >
                            {infoGraficoInscricoes.series[0].data[infoGraficoInscricoes.series[0].data.length - 1] > infoGraficoInscricoes.series[0].data[infoGraficoInscricoes.series[0].data.length - 1 - 12]
                              ? positivo
                              : infoGraficoInscricoes.series[0].data[infoGraficoInscricoes.series[0].data.length - 1] < infoGraficoInscricoes.series[0].data[infoGraficoInscricoes.series[0].data.length - 1 - 12] ? negativo : ''}
                            {Math.abs((((infoGraficoInscricoes.series[0].data[infoGraficoInscricoes.series[0].data.length - 1] / infoGraficoInscricoes.series[0].data[infoGraficoInscricoes.series[0].data.length - 1- 12]) - 1) * 100).toFixed(2))}%
                          </small>
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>



            <div className="col-12 col-sm-6 col-xl-3 mt-2">
              <div className="card border-0 shadow">
                <div className="card-body">
                  <div className="row d-block d-xl-flex align-items-center">
                    <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                      <div className="icon-shape icon-shape-secondary rounded me-4 me-sm-0">

                        <svg className="icon" width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path opacity="0.5" d="M12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22Z" fill="currentColor"/>
                          <path d="M12 8.25C12.4142 8.25 12.75 8.58579 12.75 9V11.25H15C15.4142 11.25 15.75 11.5858 15.75 12C15.75 12.4142 15.4142 12.75 15 12.75H12.75L12.75 15C12.75 15.4142 12.4142 15.75 12 15.75C11.5858 15.75 11.25 15.4142 11.25 15V12.75H9C8.58579 12.75 8.25 12.4142 8.25 12C8.25 11.5858 8.58579 11.25 9 11.25H11.25L11.25 9C11.25 8.58579 11.5858 8.25 12 8.25Z" fill="#1C274C"/>
                        </svg>

                      </div>
                      <div className="d-sm-none">
                        <h4 className="fw-extrabold h5">Reinscrições do mês</h4>
                        <h3 className="mb-1">
                          {infoGraficoInscricoes.series[1].data[infoGraficoInscricoes.series[1].data.length - 1]}
                        </h3>
                      </div>
                    </div>
                    <div className="col-12 col-xl-7 px-xl-0">
                      <div className="d-none d-sm-block">
                        <h2 className="h6 text-gray-400 mb-0">Reinscrições do mês</h2>
                        <h3 className="fw-extrabold mb-2">
                          {infoGraficoInscricoes.series[1].data[infoGraficoInscricoes.series[1].data.length - 1]}
                        </h3>
                      </div>
                      {/*
                      <small className="d-flex align-items-center text-gray-500">
                        {"01"} -{" "}
                        {"10"},
                      </small>
                      */}
                      <div className="d-flex justify-content-between">
                      <div className="small d-flex mt-1 me-2">
                        <div>
                          M. anterior{" "}
                          <small
                            className={
                              infoGraficoInscricoes.series[1].data[infoGraficoInscricoes.series[1].data.length - 1] > infoGraficoInscricoes.series[1].data[infoGraficoInscricoes.series[1].data.length - 2]
                                ? "text-success fw-bolder"
                                : infoGraficoInscricoes.series[1].data[infoGraficoInscricoes.series[1].data.length - 1] < infoGraficoInscricoes.series[1].data[infoGraficoInscricoes.series[1].data.length - 2] ? "text-danger fw-bolder" : "text-info fw-bolder"
                            }
                          >
                            {infoGraficoInscricoes.series[1].data[infoGraficoInscricoes.series[1].data.length - 1] > infoGraficoInscricoes.series[1].data[infoGraficoInscricoes.series[1].data.length - 2]
                              ? positivo
                              : infoGraficoInscricoes.series[1].data[infoGraficoInscricoes.series[1].data.length - 1] < infoGraficoInscricoes.series[1].data[infoGraficoInscricoes.series[1].data.length - 2] ? negativo : ''
                            }
                            {Math.abs((((infoGraficoInscricoes.series[1].data[infoGraficoInscricoes.series[1].data.length - 1] / infoGraficoInscricoes.series[1].data[infoGraficoInscricoes.series[1].data.length - 2]) - 1) * 100).toFixed(2))}%
                          </small>
                        </div>
                      </div>
                      <div className="small d-flex mt-1">
                        <div>
                          M. homólogo{" "}
                          <small
                            className={
                              infoGraficoInscricoes.series[1].data[infoGraficoInscricoes.series[1].data.length - 1] > infoGraficoInscricoes.series[1].data[infoGraficoInscricoes.series[1].data.length - 1 -12]
                                ? "text-success fw-bolder"
                                : infoGraficoInscricoes.series[1].data[infoGraficoInscricoes.series[1].data.length - 1] < infoGraficoInscricoes.series[1].data[infoGraficoInscricoes.series[1].data.length - 1 -12] ? "text-danger fw-bolder" : "text-info fw-bolder"
                            }
                          >
                            {infoGraficoInscricoes.series[1].data[infoGraficoInscricoes.series[1].data.length - 1] > infoGraficoInscricoes.series[1].data[infoGraficoInscricoes.series[1].data.length - 1 - 12]
                              ? positivo
                              : infoGraficoInscricoes.series[1].data[infoGraficoInscricoes.series[1].data.length - 1] < infoGraficoInscricoes.series[1].data[infoGraficoInscricoes.series[1].data.length - 1 - 12] ? negativo : ''}
                            {Math.abs((((infoGraficoInscricoes.series[1].data[infoGraficoInscricoes.series[1].data.length - 1] / infoGraficoInscricoes.series[1].data[infoGraficoInscricoes.series[1].data.length - 1- 12]) - 1) * 100).toFixed(2))}%
                          </small>
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>



          </div>
          <div className="row">
          {/*
            <div className="col-md-6">
              Lorem ipsum dolor, sit amet consectetur adipisicing elit. Saepe,
              debitis. Nulla quo ducimus nemo id aliquam ipsum accusamus eum nam
              voluptates! Ad id iure odio pariatur ab maiores dolor. Dolorum.
            </div>
          */}

            {/*
            <div className="col-md-6">
              <div className="card card-body border-0 shadow mt-2">
                <h4>Sócios Ativos</h4>
                {infoGraficoAtivos.series.length > 0 && (
                  <Grafico
                    type="line"
                    options={infoGraficoAtivos.options}
                    series={infoGraficoAtivos.series}
                    serie="Ativos"
                  />
                )}
              </div>
            </div>
            */}

            <div className="col-md-6">
              <div className="card card-body border-0 shadow mt-2">
                <h4>Entradas nos últimos 7 dias</h4>
                {infoGraficoEntradas.series.length > 0 && (
                  <Grafico
                    options={infoGraficoEntradas.options}
                    series={infoGraficoEntradas.series}
                    serie="Entradas"
                  />
                )}
              </div>
            </div>

            <div className="col-md-6">
              <div className="card card-body border-0 shadow mt-2">
                <h4>Insc./Reinsc./Dev./Canc.</h4>
                {infoGraficoInscricoes.series.length > 0 && (
                  <Grafico
                    type="line"
                    options={infoGraficoInscricoes.options}
                    series={infoGraficoInscricoes.series}
                    serie="Inscrições"
                  />
                )}
              </div>
            </div>

            {/*
            <div className="col-md-6">
              <div className="card card-body border-0 shadow mb-4">
                <h4>Receita mensal por modalidade</h4>
                {infoGraficoModalidadesReceitas.series.length > 0 && (
                  <Grafico
                    type="donut"
                    options={infoGraficoModalidadesReceitas.options}
                    series={infoGraficoModalidadesReceitas.series}
                  />
                )}
              </div>
            </div>
            */}
          </div>

          <div className="row">
            <div className="col-12">
              <div className="card card-body border-0 shadow mt-2">
                <h4>Sócios Ativos</h4>
                {infoGraficoAtivos.series.length > 0 && (
                  <Grafico
                    type="line"
                    options={infoGraficoAtivos.options}
                    series={infoGraficoAtivos.series}
                    serie="Ativos"
                  />
                )}
              </div>
            </div>
          </div>

        </>
        )}
      </main>
    </>
  );
}

export default Dashboard;
